import React from 'react';
import { profile } from '../data/profile';
type LogoProps = {
  className?: string;
};
export function Logo({
  className = 'h-9 w-9'
}: LogoProps) {
  return <img src={profile.logo} alt={`${profile.name} logo`} className={`shrink-0 object-contain ${className}`} data-id="element-572" data-mp="8v66n20dh0av" />;
}